export default __webpack_public_path__ + "static/creating-an-insight-light-86407b5874226a2a5b52b891e565d03f.mp4";